import { Alert, AlertTitle } from '@mui/material';
import { selectAlertByKey } from '@store/alerts/alertSelectors';
import { closeAlert } from '@store/alerts/alertsState';
import { useDispatch, useSelector } from 'react-redux';

const AlertMessage = ({ alertKey: key }) => {
  const alert = useSelector((state) => selectAlertByKey(state, key));
  const dispatch = useDispatch();

  return (
    <Alert
      data-testid="alert"
      severity={alert.type}
      variant="filled"
      onClose={alert.showClose ? () => dispatch(closeAlert({ key })) : null}
    >
      <AlertTitle>{alert.title}</AlertTitle>
      <span dangerouslySetInnerHTML={{ __html: alert.msg }} />
    </Alert>
  );
};

export default AlertMessage;
